// @ts-check

import { useScheduleDataGridContext } from '~/components/Forms/ScheduleDataGrid/ScheduleDataGrid.context';
import GridExportButton from '~/components/Shared/DataGrid/GridExportButton';

const EXPORTED_ROW_COUNT = 150;

export default function ScheduleDataGridExportButton() {
    const { gridRef, setRowCount } = useScheduleDataGridContext();

    return (
        <GridExportButton
            gridRef={gridRef}
            setRowCount={setRowCount}
            exportRowCount={EXPORTED_ROW_COUNT}
            fileName="ZERO Schedules Export"
        />
    );
} 